<template>
  <div>
    <transition>
      <div class="content-deactivation flexcenter">
        <div class="content-deactivation-dialog flexcenter">
          <div class="lbold font16">使用を中止します<br>（ストアページから再開できます）</div>
          <div class="flexcenter buttons">
            <button class="nobutton" type="button" @click="$emit('close');">いいえ</button>
            <button class="yesbutton" type="button" @click="$emit('deactivate', contentDetail); $emit('close');">はい</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from "@/mixin/common";
export default {
  name: "contentDeactivation",
  props: {
    contentDetail: Object
  },
  mixins: [
    common,
  ],
  created: function () {
    this.log("ContentDeactivation start created");
  },
  mounted: function () {
    this.log("ContentDeactivation start mounted");
    this.setBodyStylePosition(true);
  },
  beforeDestroy: function () {
    this.log("ContentDeactivation start beforeDestroy");
    this.setBodyStylePosition(false);
  }
};
</script>

<style lang="scss">
@import "src/assets/style/modal";
</style>



// WEBPACK FOOTER //
// ContentDeactivation.vue?cf865454